import { useInfiniteQuery } from "@tanstack/react-query";
import { operationsAPI } from "../operationsAPI.ts";
import { IOperationResponse, IOperationQueryParams } from "../types.ts";

export const operationsHistoryQueryKey_part1 = "operations-history";

export const useGetOperationsQuery = (params: IOperationQueryParams = {}) => {
  return useInfiniteQuery ({
    queryKey: [operationsHistoryQueryKey_part1, params],
    queryFn: ({ pageParam = 0 }: { pageParam?: number }) => {
      return operationsAPI.getAllOperations({
        ...params,
        page: pageParam,
      });
    },
    getNextPageParam: (lastPage?: IOperationResponse) => {
      return lastPage?.last || lastPage?.last == undefined || lastPage.pageable?.pageNumber == undefined
        ? undefined
        : lastPage.pageable.pageNumber + 1;
    },
    initialPageParam: 0,
    staleTime: 2 * 60 * 1000, // 2мин
    gcTime: 15 * 60 * 1000, // 15мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
